import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'AvailablePaymentMethods.title',
    description: 'Title for Available Payment Methods',
    defaultMessage: 'Supported payment methods',
  },
  altNameVisa: {
    id: 'AvailablePaymentMethods.altNameVisa',
    description: 'Alt name for Visa',
    defaultMessage: 'Visa',
  },
  altNameMasterCard: {
    id: 'AvailablePaymentMethods.altNameMasterCard',
    description: 'Alt name for MasterCard',
    defaultMessage: 'MasterCard',
  },
  altNameAmericanExpress: {
    id: 'AvailablePaymentMethods.altNameAmericanExpress',
    description: 'Alt name for American Express',
    defaultMessage: 'American Express',
  },
  altNameDiscover: {
    id: 'AvailablePaymentMethods.altNameDiscover',
    description: 'Alt name for Discover',
    defaultMessage: 'Discover',
  },
  altNameJCB: {
    id: 'AvailablePaymentMethods.altNameJCB',
    description: 'Alt name for JCB',
    defaultMessage: 'JCB',
  },
  altNameApplePay: {
    id: 'AvailablePaymentMethods.altNameApplePay',
    description: 'Alt name for Apple Pay',
    defaultMessage: 'Apple Pay',
  },
  altNameShopPay: {
    id: 'AvailablePaymentMethods.altNameShopPay',
    description: 'Alt name for Shop Pay',
    defaultMessage: 'Shop Pay',
  },
  altNamePayPal: {
    id: 'AvailablePaymentMethods.altNamePayPal',
    description: 'Alt name for PayPal',
    defaultMessage: 'PayPal',
  },
  altNameAffirm: {
    id: 'AvailablePaymentMethods.altNameAffirm',
    description: 'Alt name for Affirm',
    defaultMessage: 'Affirm',
  },
  altNameAcima: {
    id: 'AvailablePaymentMethods.altNameAcima',
    description: 'Alt name for Acima',
    defaultMessage: 'Acima',
  },
  altNameTrueMed: {
    id: 'AvailablePaymentMethods.altNameTrueMed',
    description: 'Alt name for TrueMed',
    defaultMessage: 'TrueMed',
  },
  altNameAmazonPay: {
    id: 'AvailablePaymentMethods.altNameAmazonPay',
    description: 'Alt name for Amazon Pay',
    defaultMessage: 'Amazon Pay',
  },
  altPurpleFinancing: {
    id: 'AvailablePaymentMethods.altPurpleFinancing',
    description: 'Alt name for Purple Financing',
    defaultMessage: 'Purple Financing',
  },
  altLink: {
    id: 'AvailablePaymentMethods.altLink',
    description: 'Alt name for Link',
    defaultMessage: 'Link',
  }
});
